/**
 * Shipper HQ
 *
 * @copyright Copyright (c) 2026 Zowta Ltd (http://www.shipperhq.com)
 * Copyright, 2026, Zowta, LLC - US license
 */

import React from 'react'
import Logo from 'assets/images/frontend/shq-logo-hz-3c.svg'

/**
 * LoginHeader Properties
 */

export default function LoginHeader(props) {
    const { title, columns, subtitle, showTagline = false } = props
    const style = {}

    if (columns) {
        style.gridColumnEnd = columns + 1
    }

    return (
        <header className="signup-intro" style={style}>
            <a href="/">
                <img src={Logo} alt="ShipperHQ" />
            </a>
            {showTagline && (
                <p className="signup-tagline">Trusted by 6,000+ merchants</p>
            )}
            {title && <h1>{title}</h1>}
            {subtitle && <h4>{subtitle}</h4>}
        </header>
    )
}
